export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-900-normal.woff2?49bb7a63f516bec2e6959609ecacb3a4";